import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.params = {
      ...config.params,
      Authorization: `Bearer ${token}`,
    };
  }
  return config;
});

// Auth API
export const authAPI = {
  googleLogin: (token) => api.post('/api/auth/google', { token }),
  demoLogin: () => api.post('/api/auth/demo'),
  getCurrentUser: () => api.get('/api/auth/me'),
};

// CV API
export const cvAPI = {
  createJob: (formData) => api.post('/api/cv/jobs', formData),
  getJobStatus: (jobId) => api.get(`/api/cv/jobs/${jobId}`),
  listJobs: (limit = 10) => api.get('/api/cv/jobs', { params: { limit } }),
  downloadCV: (jobId) => {
    const token = localStorage.getItem('access_token');
    return `${API_BASE_URL}/api/cv/jobs/${jobId}/download?Authorization=Bearer%20${token}`;
  },
};

// Quota API
export const quotaAPI = {
  getQuota: () => api.get('/api/quota'),
};

export default api;
